module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title-banner":"What’s on ?","card-btn":"Check it"},"fr":{"title-banner":"Quoi de neuf ?","card-btn":"Voir"}}')
  delete Component.options._Ctor
}
